// extracted by mini-css-extract-plugin
export var dataCell = "_nb-2";
export var dataRow = "_nb-0";
export var headerRow = "_nb-1";